/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const Messages = {
  ROL: {
    CREATION_TITLE: 'Nuevo rol y permiso',
    CREATION_SUBTITLE: 'Invitar a otros usuarios a colaborar en tus empresas',
    CREATE_BUTTON: 'Crear rol',
    EDIT_BUTTON: 'Guardar cambios',
    CLOSE_BUTTON: 'Cerrar',
    CREATE_SUCCESS: 'El rol se creó correctamente.',
    UPDATE_SUCCESS: 'El rol se actualizó correctamente.',
    DELETE_SUCCESS: 'El rol se eliminó correctamente',
    LICENSE_EMPTY: 'No se encontraron licencias para este rol.',
    APPS_EMPTY: 'No se encontraron aplicaciones administrables para esta licencia.',
    EMPTY_PERMISSIONS: 'No has seleccionado permisos para este rol.',
    EMPTY_UPDATE_PERMISSIONS: 'No se detectaron cambios por guardar en rol ',
    GET_ERROR: 'Ocurrió un error al obtener los roles de esta licencia/aplicación',
    DELETE_ERROR: 'Ocurrió un error al intentar el eliminar el rol. Intenta más tarde',
    SETTINGS_GET_ERROR: 'Ocurrió un error al obtener la información de el rol seleccionado.',
    SETTINGS_GET_EMPTY: 'No se encontró información de este rol.',
    SETTINGS_SAVE_ERROR: 'Ocurrió un error al intentar guardar la información del rol.',
    GENERAL_TITLE_NOTIFICATION: 'Roles',
    SAVE_TITLE_NOTIFICATION: 'Guardar Rol',
    UPDATE_TITLE_NOTIFICATION: 'Actualizar Rol',
    DELETE_TITLE_NOTIFICATION: 'Eliminar Rol',
    UPDATED_CONFIG_AUTH: 'La sesión se ha actualizado.',
    DELETE_MESSAGE: 'Estás seguro de eliminar el rol',
    DELETE_CONFIRM: 'Sí, eliminar',
    LIMIT_ERROR: 'Se ha alcanzado el límite máximo de roles para este producto',
    NEW_LABEL: 'Nuevo rol',
  },
  STEPS: {
    GENERAL_INFO: 'Información general',
    MODULE_PERMISSIONS: 'Permisos por módulo',
    //CATALOG_PERMISSIONS: 'Permisos por catálogo',
  },
  ACTIONS: {
    CANCEL: 'Cancelar',
    CONTINUE: 'Continuar',
  },
  PERMISSIONS: {
    GET_EMPTY: 'No se encontraron permisos asociados a la aplicación',
    GET_GENERIC_ERROR: 'Ocurrió un error al obtener los permisos de la aplicación',
    GET_EMPTY_BY_USER: 'No se encontraron permisos asociados de la aplicación a este usuario',
    GET_GENERIC_ERROR_BY_USER: 'Ocurrió un error al obtener los permisos de la aplicación para el usuario',
    ACCESS_DENIED: 'El usuario no tiene permisos para esta acción',
    USER_DENIED: 'No se encontraron permisos para administrar aplicaciones en esta licencia',
    NOT_FOUND: 'No se encontraron permisos asociados',
  },
  ERROR_EMPTY_APPS: 'Para poder administrar los roles de esta licencia debe contar con al menos un módulo o aplicación.',
  ERROR_GENERIC: 'Error no controlado',
  REINTENT_LABEL: 'Intenta de nuevo más tarde.',
  PARAMS_EMPTY: 'Los parámetros requeridos no están completos.',
  USER_SERVICE_NOT_AVAILABLE: 'El servicio de usuarios no está disponible. Intenta de nuevo más tarde.',
  RBAC_SERVICE_NOT_AVAILABLE: 'Los servicios de roles y permisos no están disponibles. Intenta de nuevo más tarde.',
  ERROR_CONFIRM_OK: 'Ok',
  ERROR_EMPTY_SCHEMAS: 'No se encontró esquema de permisos por aplicación para administrar.',
  AUTH_ERROR: 'Intenta recargando la página para actualizar la sesión.',
};

export const ValidatorMessages = {
  requiredLicense: 'Selecciona la licencia',
  requiredApplication: 'Selecciona la aplicación',
  requiredRolName: 'Ingresa el nombre del rol',
  requiredRolAlias: 'Ingresa el alias del rol',
  alphaNumeric: 'Ingresa letras, números y los siguientes caracteres: -_',
  invalidMaxLength: 'El texto es muy largo. El límite de caracteres es: ',
};